/**
 * Single seam for the native recovery handoff: full-page navigation to a
 * caller-supplied target. Kept as its own module so tests can substitute the
 * dispatch without touching window.location.
 */
export const openNativeRecoveryTarget = (url: string): void => {
  window.location.assign(url);
};
